class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
		this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
		this.setHeaderCartIconAccessibility();

		subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
			if (data.source === "product-form") {
				this.renderContents(data.cartData);
			}
		});
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		if (!cartLink) return;

		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
				const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true },
		);

		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState, shouldOpen = true) {
		this.productId = parsedState.id;

		if (this.getSectionsToRender()) {
			this.getSectionsToRender().forEach((section) => {
				const sectionElement = document.querySelector(section.selector) || document.getElementById(section.id);

				if (sectionElement && parsedState.sections?.[section.id]) {
					const newHtml = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
					if (newHtml !== null) {
						// ← seulement si on a trouvé quelque chose
						sectionElement.innerHTML = newHtml;
					}
				}
			});
		}

		// On vient d'ajouter un produit : le panier n'est donc plus vide.
		// La classe is-empty vit sur l'élément <cart-drawer> (this), pas sur
		// .drawer__inner — c'est pour ça que l'ancienne version ne la retirait jamais.
		this.classList.remove("is-empty");

		const drawerInner = this.querySelector(".drawer__inner");
		if (drawerInner) drawerInner.classList.remove("is-empty");

		if (shouldOpen) {
			setTimeout(() => {
				this.open();
			});
		}
	}
	getSectionInnerHTML(html, selector = ".shopify-section") {
		const parsed = new DOMParser().parseFromString(html, "text/html");
		const el = parsed.querySelector(selector);
		return el ? el.innerHTML : null; // ← null au lieu de crash
	}

	// cart-icon-bubble retiré — on gère la bulle manuellement
	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble", // L'ID de la section Shopify qui contient ton icône
				selector: "#cart-icon-bubble", // Le sélecteur CSS de ton lien de panier
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	// cart-icon-bubble retiré — on gère la bulle manuellement
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);
